export default __webpack_public_path__ + "1b5f60cf7b6ac800a83aec8df56a1d17.woff2";